// Centralized auth token store — the ONLY module allowed to touch the
// underlying storage. Web/PWA uses localStorage (accepted trade-off: the app
// has no dangerouslySetInnerHTML/XSS surface and ships behind CSP); a native
// Keychain/Keystore adapter can be swapped in here without touching callers.
const KEY = "ss_token";

export const getToken = () => localStorage.getItem(KEY);
export const setToken = (value) => localStorage.setItem(KEY, value);
export const clearToken = () => localStorage.removeItem(KEY);

// Storage events are delivered to other same-origin tabs, not the tab that
// wrote the token. Read current storage in the caller, never trust a delayed
// event's newValue as the current session.
export const subscribeTokenChanges = (onChange) => {
  const listener = (event) => {
    if (event.storageArea !== localStorage) return;
    if (event.key === KEY || event.key === null) onChange();
  };
  window.addEventListener("storage", listener);
  return () => window.removeEventListener("storage", listener);
};
